import { render, staticRenderFns } from "./MiCuenta.vue?vue&type=template&id=33c45c94&scoped=true&"
import script from "./MiCuenta.vue?vue&type=script&lang=js&"
export * from "./MiCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c45c94",
  null
  
)

export default component.exports